import { LoginProjectConfiguration } from '../../../api';
import { BanOptions, Group, User } from '../../../api/users/types';

export type UserState = {
  saveDataFetching: boolean;
  resetPasswordFetching: boolean;
  newEmailFetching: boolean;
  resendEmailFetching: boolean;
  newPhoneFetching: boolean;
  unbanFetching: boolean;
  newEmail: string;
  emailTaken: string;
  newPhone: string;
  phoneEdit: boolean;
  emailEdit: boolean;
  isXsollaStorage: boolean;
  isChangingEmailAllowed: boolean;
  user: User | Partial<User>;
  groups: Array<Group>;
  emailError: string;
  phoneError: string;
  submitError: string;
  newServerCustomId: string;
  serverCustomIdEdit: boolean;
  newServerCustomIdFetching: boolean;
  serverCustomIdError: string;
};

export type FormValues = {
  user_groups: number[];
  country: string | null;
  age: string | null;
};

export type GetDataPayload = {
  user: User;
  groups: Array<Group>;
  configuration: LoginProjectConfiguration | null;
};

export enum ActionType {
  resetPasswordStart = 'resetPasswordStart',
  resetPasswordEnd = 'resetPasswordEnd',
  banUserEnd = 'banUserEnd',
  unbanUserStart = 'unbanUserStart',
  unbanUserEnd = 'unbanUserEnd',
  resendEmailStart = 'resendEmailStart',
  resendEmailEnd = 'resendEmailEnd',
  emailEditToggle = 'emailEditToggle',
  changeEmail = 'changeEmail',
  changeEmailStart = 'changeEmailStart',
  changeEmailError = 'changeEmailError',
  changeEmailForceUnlink = 'changeEmailForceUnlink',
  changeEmailEnd = 'changeEmailEnd',
  phoneEditToggle = 'phoneEditToggle',
  changePhone = 'changePhone',
  changePhoneStart = 'changePhoneStart',
  changePhoneError = 'changePhoneError',
  changePhoneEnd = 'changePhoneEnd',
  submitStart = 'submitStart',
  submitSuccess = 'submitSuccess',
  submitFail = 'submitFail',
  changeServerCustomId = 'changeServerCustomId',
  changeServerCustomIdStart = 'changeServerCustomIdStart',
  changeServerCustomIdError = 'changeServerCustomIdError',
  changeServerCustomIdEnd = 'changeServerCustomIdEnd',
  serverCustomIdEditToggle = 'serverCustomIdEditToggle'
}

export type Action =
  | { type: ActionType.resetPasswordStart }
  | { type: ActionType.resetPasswordEnd }
  | { type: ActionType.banUserEnd; payload: BanOptions }
  | { type: ActionType.unbanUserStart }
  | { type: ActionType.unbanUserEnd }
  | { type: ActionType.resendEmailStart }
  | { type: ActionType.resendEmailEnd }
  | { type: ActionType.emailEditToggle }
  | { type: ActionType.changeEmail; payload: string }
  | { type: ActionType.changeEmailStart }
  | { type: ActionType.changeEmailError; payload: string }
  | { type: ActionType.changeEmailForceUnlink; payload: string }
  | { type: ActionType.changeEmailEnd }
  | { type: ActionType.changePhone; payload: string }
  | { type: ActionType.phoneEditToggle }
  | { type: ActionType.changePhoneStart }
  | { type: ActionType.changePhoneError; payload: string }
  | { type: ActionType.changePhoneEnd }
  | { type: ActionType.submitStart }
  | { type: ActionType.submitSuccess; payload: Array<Group> }
  | { type: ActionType.submitFail; payload: string }
  | { type: ActionType.changeServerCustomId; payload: string }
  | { type: ActionType.changeServerCustomIdStart }
  | { type: ActionType.changeServerCustomIdError; payload: string }
  | { type: ActionType.changeServerCustomIdEnd }
  | { type: ActionType.serverCustomIdEditToggle };
